module.exports = __webpack_public_path__ + "static/media/Weddings2008.0d51e022.jpg";